// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { media, UNSAFE_media } from "@atlaskit/primitives/responsive";

import { Logo } from "../../../libraries/wpl/foundations/src/index";

import { componentStyle } from "./global-footer-top";

// ==================================================================
// Style Functions
// ==================================================================
const logoColumnStyle = css`
    border: 0;
    padding: 16px;
    ${media.above.md} {
        margin-left: 8.33333%;
        width: 16.66666%;
        position: relative;
        min-height: 1px;
    }
    ${UNSAFE_media.below.md} {
        width: 100%;
    }
`;

const logoColumnAnchorTagStyle = css`
    color: #42526e;
    font-size: 0.875rem;
    line-height: 1.125;
    text-decoration: none;
    margin-bottom: 0;
    display: block;
    vertical-align: baseline;
    svg {
        width: 125px;
        height: auto;
        pointer-events: none;
        margin-bottom: 16px;
        vertical-align: bottom;
        max-width: 100%;
    }
`;

// ==================================================================
// Rendering Functions
// ==================================================================
export const LogoLinkContainer = () => {
    const href = "/wac";

    //TODO: Figure out data event values
    const dataEvent = "some-random-data-event";
    const dataUuid = "some-random-data-uuid";
    const dataEventComponent = "some-random-data-event-component";
    const dataEventContainer = "some-random-data-event-container";
    const dataSchemaVersion = "1";

    return (
        <div css={logoColumnStyle}>
            <div css={componentStyle}>
                <a
                    css={logoColumnAnchorTagStyle}
                    href={href}
                    data-event={dataEvent}
                    data-uuid={dataUuid}
                    data-event-component={dataEventComponent}
                    data-event-container={dataEventContainer}
                    data-schema-version={dataSchemaVersion}
                >
                    <Logo brand="atlassian" type="logo" appearance="neutral" />
                </a>
            </div>
        </div>
    );
};
